import { Routes } from '@angular/router';
import { MainGestaoBolseirosComponent } from './components/main-gestao-bolseiros/main-gestao-bolseiros.component';
import { ListaInstituicoesEnsinoComponent } from './components/instituicoes-ensino/lista-instituicoes-ensino/lista-instituicoes-ensino.component';
import { PerfilInstituicaoEnsinoComponent } from './components/instituicoes-ensino/perfil-instituicao-ensino/perfil-instituicao-ensino.component';
import { ListaBolseirosComponent } from './components/bolseiros/lista-bolseiros/lista-bolseiros.component';
import { ListaBolsasComponent } from './components/bolsas/lista-bolsas/lista-bolsas.component';
import { DetalheBolsaComponent } from './components/bolsas/detalhe-bolsa/detalhe-bolsa.component';
import { ListaTipoBolsaComponent } from './components/tipo-de-bolsas/lista-tipo-de-bolsas/lista-tipo-de-bolsas.component';
import { DetalheInstituicaoGestoraComponent } from './components/instituicoes-gestora/detalhe-instituicao-gestora/detalhe-instituicao-gestora.component';
import { DetalheBolseiroComponent } from './components/bolseiros/detalhe-bolseiro/detalhe-bolseiro.component';
import { HomeProgramaFormacaoComponent } from './components/programa-formacao/home-programa-formacao/home-programa-formacao.component';
import { CadastrarBolseirosComponent } from './components/bolseiros/cadastrar-bolseiros/cadastrar-bolseiros.component';
import { HomeInstituicoesGestorasComponent } from './components/instituicoes-gestora/home-instituicoes-gestoras/home-instituicoes-gestoras.component';
import { HomeAuxilioFormacaoComponent } from './components/auxilio-formacao/home-auxilio-formacao/home-auxilio-formacao.component';
import { CadastrarAuxilioFormacaoComponent } from './components/auxilio-formacao/cadastrar-auxilio-formacao/cadastrar-auxilio-formacao.component';
import { DetalhesAuxilioFormacaoComponent } from './components/auxilio-formacao/detalhes-auxilio-formacao/detalhes-auxilio-formacao.component';
import { AddRepresentanteComponent } from './components/instituicoes-ensino/add-representante/add-representante.component';
import { AddRepresentanteGestaoEmpresasComponent } from './components/instituicoes-gestora/detalhe-instituicao-gestora/add-representante/add-representante.component';
import { HomeEmitDocumentComponent } from './components/emissao-documentos/home-emit-document/home-emit-document.component';
import { ListaCursosComponent } from './components/cursos/lista-cursos/lista-cursos.component';
import { CadastrarCursoComponent } from './components/cursos/cadastrar-curso/cadastrar-curso.component';
import { DetalheCursosComponent } from './components/cursos/detalhe-cursos/detalhe-cursos.component';
import { HomeRenovacaoComponent } from './components/renovacao/home-renovacao/home-renovacao.component';
import { ProcessoRenovacaoComponent } from './components/renovacao/processo-renovacao/processo-renovacao.component';
import { EditRepresentanteComponent } from './components/instituicoes-gestora/detalhe-instituicao-gestora/add-representante/components/edit-representante/edit-representante.component';

export const gestaoBolseirosRoutes: Routes = [
  {
    path: '',
    component: MainGestaoBolseirosComponent,
    children: [
      {
        path: 'instituicao-ensino',
        children: [
          {
            path: '',
            component: ListaInstituicoesEnsinoComponent,
          },
          {
            path: 'detalhe-instituicao/:id',
            component: PerfilInstituicaoEnsinoComponent,
          },
          {
            path: 'add-representante/:id',
            component: AddRepresentanteComponent,
          },
        ],
      },
      {
        path: 'bolseiros',
        children: [
          {
            path: '',
            component: ListaBolseirosComponent,
          },
          {
            path: 'lista-bolseiros',
            component: ListaBolseirosComponent,
          },
          {
            path: 'detalhe-bolseiro/:id',
            component: DetalheBolseiroComponent,
          },
          {
            path: 'cadastrar-bolseiro',
            component: CadastrarBolseirosComponent,
          },
        ],
      },
      {
        path: 'cursos',
        children: [
          {
            path: '',
            component: ListaCursosComponent,
          },
          {
            path: 'lista-cursos',
            component: ListaCursosComponent,
          },
          {
            path: 'detalhe-cursos/:id',
            component: DetalheCursosComponent,
          },
          {
            path: 'cadastrar-curso',
            component: CadastrarCursoComponent,
          },
        ],
      },
      {
        path: 'bolsas',
        children: [
          {
            path: '',
            component: ListaBolsasComponent,
          },
          {
            path: 'detalhe-bolsa/:id',
            component: DetalheBolsaComponent,
          },
        ],
      },
      {
        path: 'auxilio-formacao',
        children: [
          {
            path: '',
            component: HomeAuxilioFormacaoComponent,
          },
         {
            path: 'cadastrar-auxilio-formacao/:numeroBI',
            component: CadastrarAuxilioFormacaoComponent,
          },
          {
            path: 'detalhes-auxilio-formacao/:id',
            component: DetalhesAuxilioFormacaoComponent,
          },
        ]
      },
      {
        path: 'programa-formacao',
        children: [
          {
            path: '',
            component: HomeProgramaFormacaoComponent,
          },
        ],
      },
      {
        path: 'empresa-gestora',
        children: [
          {
            path: '',
            component: HomeInstituicoesGestorasComponent,
          },
          {
            path: 'detalhe-instituicao-gestora/:id',
            component: DetalheInstituicaoGestoraComponent,
          },
          {
            path: 'add-representante/:id',
            component: AddRepresentanteGestaoEmpresasComponent,
          },
          {
            path: 'edit-representante/:id',
            component: EditRepresentanteComponent,
          }
        ],
      },
      {
        path: 'tipo-bolsa',
        children: [
          {
            path: '',
            component: ListaTipoBolsaComponent,
          },
        ],
      },
      {
        path: 'emissao-documentos',
        children: [
          {
            path: '',
            component: HomeEmitDocumentComponent,
          },
        ],
      },
      {
        path:'renovacao',
        children: [
          {
            path: '',
            component: HomeRenovacaoComponent,
          },
          {
            path: 'processo-renovacao/:id',
            component: ProcessoRenovacaoComponent,
          },
        ],
      }
    ],
  },
];
